const AccentTitle = ({
  title,
  subTitle,
}: {
  title: string;
  subTitle?: string;
}) => {
  return (
    <div className="py-4">
      <h3 className="px-4 py-2 border-l-4 border-primaryColor-normal text-black font-medium text-xl">
        {title}
      </h3>
      {subTitle && <p className="px-4 text-sm text-neutralColor-normal">{subTitle}</p>}
    </div>
  );
};

export default AccentTitle;
